import { getEngineerConfirmationData } from "../../utils/api";
import { msgError } from "../../utils/notification";

export const getConfirmedOrders = async function(
    reqBody, 
    setLoading, 
    setData, 
    setTableParams,
    tableParams,
    setTotalEntries,
    totalEntries,
    setLastEntry,
    messageApi
) {
    try {
      setLoading(true);
      const resData = await getEngineerConfirmationData(reqBody);

      setData(resData.data);
      setLoading(false);
      setTableParams({
        ...tableParams,
        pagination: {
            ...tableParams.pagination,
            total: resData.totalCount,
        },
      });
      setTotalEntries(resData.totalCount);
      setLastEntry(() => {
        if (
            tableParams.pagination.pageSize * tableParams.pagination.current > totalEntries
        ) {
            return totalEntries;
        } else {
            return (
                tableParams.pagination.pageSize * tableParams.pagination.current
            );
        }
      });
    } catch (err) {
      console.log(err);
      msgError('Error Occurred', messageApi);
    } finally {
      setLoading(false);
    }
}

// zebra-striped table
export const getRowClassName = (record, index) => {
    if (index % 2 === 1) {
      return "zebra-highlight"; // Apply zebra-striping to odd-indexed rows
    }
    return "";
};

export const editOrder = (navigate, navUrl, createSearchParams, darId, orderId, principalId, branchId, quotRefNo, prevYear, nextYear) => {
    navigate({
      pathname: navUrl,
      search: createSearchParams({
        darId,
        orderId
      }).toString(),
    }, {
      state: {
        principalId,
        branchId,
        quotRefNo,
        prevYear,
        nextYear
      }
    });
}

export const handleTableChange = (
    setStartEntry, 
    setLastEntry, 
    setTableParams, 
    setData,
    tableParams, 
    totalEntries, 
    pagination, 
    filters, 
    sorter
) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    setStartEntry(() => {
      if (pagination.current === 1) {
        return 1;
      } else {
        return (
          pagination.pageSize * pagination.current - pagination.pageSize + 1
        );
      }
    });

    setLastEntry(() => {
      if (pagination.pageSize * pagination.current > totalEntries) {
        return totalEntries;
      } else {
        return pagination.pageSize * pagination.current;
      }
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
};